import React from 'react';
import { AccountPageLayout } from 'pages/Account/components';

import { Services } from 'services';
import { Store } from 'store';
import { FormattedMessage } from 'react-intl';
import { Box, Text } from '@clariness/clarikit-react';

export const MySites = () => {
  const { user } = Store.useUser();

  const { sites } = Services.InvestigatorSites.useGetInvestigatorSites(
    user?.id || ''
  );
  return (
    <AccountPageLayout>
      <AccountPageLayout.Heading>
        <FormattedMessage id="is.sites_link" defaultMessage="My Sites" />
      </AccountPageLayout.Heading>
      <Box style={{ marginBottom: '20px' }}>
        <AccountPageLayout.Paragraph>
          <FormattedMessage
            id="is.investigator.sites_list"
            defaultMessage="List of the sites you are assigned to"
          />
        </AccountPageLayout.Paragraph>
      </Box>
      <Box display="flex" flexDirection="column" gap="20px" width="100%">
        {sites?.map((site) => (
          <Box
            key={site.id}
            display="flex"
            flexDirection="column"
            gap="20px"
            data-test-id="my-sites-item"
          >
            <Box style={{ marginBottom: '10px' }}>
              <Text
                as="h4"
                variant="headingXs"
                color="color-gray-variant-1"
                breakWord
              >
                {site.name}
              </Text>
            </Box>
            <Box display="flex" flexDirection="column" gap="15px">
              <Text as="p" breakWord>
                {site.street}
              </Text>
              <Text as="p" breakWord>
                {site.zipCode} {site.city}
              </Text>
              <Text as="p" breakWord>
                {site.country}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </AccountPageLayout>
  );
};
